import { render, staticRenderFns } from "./EnabledSwitch.vue?vue&type=template&id=a6aac0c4&scoped=true&"
import script from "./EnabledSwitch.vue?vue&type=script&lang=ts&"
export * from "./EnabledSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aac0c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VSwitch})
